import { render, staticRenderFns } from "./ModPwd.vue?vue&type=template&id=c2309f54&"
import script from "./ModPwd.vue?vue&type=script&lang=js&"
export * from "./ModPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports